import { h, Host } from '@stencil/core';
import cn from 'classnames';
import { DEFAULT_LINE_HEIGHT } from '@pes-ui/utils';
import { isMobile } from '../../../globals/utils';
export class Description {
  constructor() {
    this.getHeightLimit = () => {
      const { desktop, mobile } = this.numLinesToShow;
      const numLinesToShow = isMobile() ? mobile : desktop;
      const pStyle = window.getComputedStyle(this.paragraph, null);
      const lineHeight = (pStyle === null || pStyle === void 0 ? void 0 : pStyle.lineHeight) !== 'normal' ? pStyle.lineHeight : DEFAULT_LINE_HEIGHT;
      return numLinesToShow * parseInt(lineHeight, 10);
    };
    this.getShowReadMore = () => {
      var _a;
      if (this.isSafariBrowser() && this.isShowReadMore)
        return true;
      return (((_a = this.paragraph) === null || _a === void 0 ? void 0 : _a[this.isSafariBrowser() ? 'clientHeight' : 'scrollHeight']) > this.heightLimit);
    };
    this.handleResizeWindow = () => {
      this.heightLimit = this.getHeightLimit();
      this.isShowReadMore = this.getShowReadMore();
    };
    this.handleClick = () => {
      this.isExpanded = !this.isExpanded;
      if (!this.isSafariBrowser() && this.paragraph) {
        this.paragraph.classList.toggle('expanded');
      }
    };
    this.text = undefined;
    this.expandLabel = undefined;
    this.collapseLabel = undefined;
    this.numLinesToShow = { desktop: 5, mobile: 4 };
    this.isBanner = false;
    this.isPdp = false;
    this.variant = 'dark';
    this.isExpanded = false;
    this.isShowReadMore = false;
    this.heightLimit = undefined;
  }
  componentDidLoad() {
    this.heightLimit = this.getHeightLimit();
    this.isShowReadMore = this.getShowReadMore();
    window.addEventListener('resize', this.handleResizeWindow);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResizeWindow);
  }
  getWrapped(text) {
    return `<!--GEN_DESC_BEGIN-->${text}<!--GEN_DESC_END-->`;
  }
  renderSafariText() {
    return (h("p", { class: cn('description-text description-text--safari', { 'pdp-long-desc': this.isPdp }), ref: (el) => (this.paragraph = el) }, this.isShowReadMore ? (h("pes-ellipsis", { maxHeight: this.isExpanded ? 'none' : `${this.heightLimit}px`, content: this.getWrapped(this.text), isPdpDesc: this.isPdp })) : (h("span", { innerHTML: this.getWrapped(this.text) }))));
  }
  renderText() {
    return (h("div", { class: cn('text-container', { 'pdp-long-desc': this.isPdp }, {
        'text-container--banner': this.isBanner,
      }), ref: (el) => {
        this.paragraph = el;
      } }, h("span", { class: cn({ 'description__content font-m': this.isPdp }, { 'description-text': !this.isPdp }), innerHTML: this.getWrapped(this.text) })));
  }
  isSafariBrowser() {
    return (navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') <= -1);
  }
  render() {
    if (!this.text)
      return null;
    return (h(Host, { class: this.variant }, this.isSafariBrowser() ? this.renderSafariText() : this.renderText(), this.isPdp && this.isShowReadMore && this.getShowReadMore() && (h("div", { class: this.isExpanded ? '' : 'blurred-text' }, '')), this.isShowReadMore && this.getShowReadMore() && (h("qds-button", { size: "standard", importance: this.variant === 'light' ? 'emphasized' : 'subdued', class: cn('show-button', { 'font-m': this.isPdp }), action: this.isExpanded ? 'dropdown-close' : 'dropdown', onClick: this.handleClick, text: this.isExpanded ? this.collapseLabel : this.expandLabel }))));
  }
  static get is() { return "pes-description"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["description.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["description.css"]
    };
  }
  static get properties() {
    return {
      "text": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "text",
        "reflect": false
      },
      "expandLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Label for collapsed state"
        },
        "attribute": "expand-label",
        "reflect": false
      },
      "collapseLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "label for expanded state"
        },
        "attribute": "collapse-label",
        "reflect": false
      },
      "numLinesToShow": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "{ desktop: number; mobile: number; }",
          "resolved": "{ desktop: number; mobile: number; }",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "number of lines to display\nfor desktop and mobile views"
        },
        "defaultValue": "{ desktop: 5, mobile: 4 }"
      },
      "isBanner": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-banner",
        "reflect": false,
        "defaultValue": "false"
      },
      "isPdp": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Theme for the component"
        },
        "attribute": "is-pdp",
        "reflect": false,
        "defaultValue": "false"
      },
      "variant": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'dark' | 'light'",
          "resolved": "\"dark\" | \"light\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "variant",
        "reflect": false,
        "defaultValue": "'dark'"
      }
    };
  }
  static get states() {
    return {
      "isExpanded": {},
      "isShowReadMore": {},
      "heightLimit": {}
    };
  }
}
